export enum Color {
    white = "#FFFFFF",
    white30 = "#FFFFFF4D",

    black = "#001A30",

    green = "#03A167",

    yellow100 = "#F5A623",
    yellow10 = "#FEf6E8",

    red100 = "#D71D4F",
    red10 = "#ff000033",

    azure = "#025BA9",
    saphire = "#3888D6",

    blue10 = "#EEF2FA",
    blue100 = "#779BBB",
    blue150 = "#0867BA",
    blue200 = "#004E8F",

    gray10 = "#F5F5FA",
    gray25 = "#ECEDEE",
    gray50 = "#D9D9D9",
    gray100 = "#D0D4DA",
    gray200 = "#617384",

    textPrimary = "#1B1B1B",
    textSecondary = "#617384",
}
